import React from 'react';

import { DateInput, Input, Select } from 'design-system';

import { Grid, SearchFieldWrap, SearchHint } from './styles';

const SearchIcon = (): JSX.Element => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M7.25 12.5C10.1495 12.5 12.5 10.1495 12.5 7.25C12.5 4.35051 10.1495 2 7.25 2C4.35051 2 2 4.35051 2 7.25C2 10.1495 4.35051 12.5 7.25 12.5Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14L11.1 11.1"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export type FiltersBarProps = {
  searchValue?: string;
  dueDateValue?: string;
  competenceValue?: string;
  statusValue?: string;
  competenceOptions?: Array<{ value: string; label: string }>;
  searchHint?: string;
  onSearchChange?: (value: string) => void;
  onDueDateChange?: (value: string) => void;
  onCompetenceChange?: (value: string) => void;
  onStatusChange?: (value: string) => void;
  className?: string;
};

const FiltersBar = ({
  searchValue = '',
  dueDateValue = '',
  competenceValue = '',
  statusValue = '',
  competenceOptions = [],
  searchHint,
  onSearchChange,
  onDueDateChange,
  onCompetenceChange,
  onStatusChange,
  className,
}: FiltersBarProps): JSX.Element => {
  return (
    <Grid className={className}>
      <SearchFieldWrap>
        <Input
          label="Buscar por"
          placeholder="Nº do boleto ou valor"
          shape="pill"
          fullWidth
          trailingIcon={<SearchIcon />}
          value={searchValue}
          onChange={(event) => onSearchChange?.(event.target.value)}
        />
        {searchHint && <SearchHint>{searchHint}</SearchHint>}
      </SearchFieldWrap>
      <DateInput
        label="Data de vencimento"
        shape="pill"
        fullWidth
        withPicker
        value={dueDateValue}
        onChange={(event) => onDueDateChange?.(event.target.value)}
      />
      <Select
        label="Competência"
        shape="pill"
        fullWidth
        required
        value={competenceValue}
        onChange={(event) => onCompetenceChange?.(event.target.value)}
      >
        <option value="">Selecione</option>
        {competenceOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </Select>
      <Select
        label="Status"
        shape="pill"
        fullWidth
        required
        value={statusValue}
        onChange={(event) => onStatusChange?.(event.target.value)}
      >
        <option value="">Selecione</option>
        <option value="a_vencer">À vencer</option>
        <option value="vencido">Vencido</option>
        <option value="pago">Pago</option>
      </Select>
    </Grid>
  );
};

export default FiltersBar;
